import { SEO } from "../components/SEO";
import { DemoBadge, SectionHeading } from "../components/ui";
import { demoPerformance } from "../data/demo";

export function PerformancePage() {
  const totalTips = demoPerformance.reduce((sum, item) => sum + item.tips, 0);
  const wins = demoPerformance.reduce((sum, item) => sum + item.wins, 0);
  const profit = demoPerformance.reduce((sum, item) => sum + item.profit, 0);
  const winRate = (wins / totalTips) * 100;
  const roi = (profit / totalTips) * 100;
  return (
    <div className="page-shell py-10 sm:py-14">
      <SEO
        title="Tip performance"
        description="Transparent sample tip performance including wins, losses, ROI and monthly results."
        path="/tips/performance"
      />
      <SectionHeading
        headingLevel={1}
        eyebrow="Full record"
        title="Tip performance"
        description="Demo performance data illustrates the reporting format. It is not evidence of real profitability."
      />
      <div className="mb-6">
        <DemoBadge />
      </div>
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-5">
        {[
          ["Total tips", totalTips],
          ["Wins", wins],
          ["Losses", totalTips - wins],
          ["Win rate", `${winRate.toFixed(1)}%`],
          ["P/L", `${profit > 0 ? "+" : ""}${profit.toFixed(1)}u`],
        ].map(([label, value]) => (
          <div className="surface rounded-2xl p-5" key={String(label)}>
            <div className="text-xs uppercase tracking-wider text-muted">
              {label}
            </div>
            <div className="display mt-2 text-2xl font-black">{value}</div>
          </div>
        ))}
      </div>
      <section className="surface mt-6 rounded-2xl p-6">
        <div className="flex items-end justify-between">
          <div>
            <h2 className="display text-xl font-black">Monthly profit/loss</h2>
            <p className="mt-1 text-xs text-muted">
              Flat one-unit stake · sample data
            </p>
          </div>
          <div className="text-right">
            <div className="text-xs text-muted">Sample ROI</div>
            <div className="text-lg font-black text-lime">
              {roi.toFixed(1)}%
            </div>
          </div>
        </div>
        <div className="mt-8 flex h-56 items-center gap-3 border-b border-soft">
          {demoPerformance.map((month) => {
            const positive = month.profit >= 0;
            return (
              <div
                className="flex h-full flex-1 flex-col items-center justify-end"
                key={month.month}
              >
                <div
                  className={`flex w-full max-w-14 items-start justify-center rounded-t-lg pt-2 text-xs font-black ${positive ? "bg-lime text-[#07110d]" : "bg-rose-400/60"}`}
                  style={{
                    height: `${Math.max(24, (Math.abs(month.profit) / 6) * 180)}px`,
                  }}
                >
                  {positive ? "+" : ""}
                  {month.profit}
                </div>
                <div className="mt-2 text-[10px] text-muted">
                  {month.month.slice(0, 3)}
                </div>
              </div>
            );
          })}
        </div>
      </section>
      <section className="surface mt-6 overflow-hidden rounded-2xl">
        <div className="grid grid-cols-4 gap-2 border-b border-soft p-4 text-[10px] font-bold uppercase tracking-wider text-muted">
          <div>Month</div>
          <div className="text-right">Tips</div>
          <div className="text-right">Wins</div>
          <div className="text-right">P/L</div>
        </div>
        {demoPerformance.map((month) => (
          <div
            className="grid grid-cols-4 gap-2 border-b border-soft p-4 text-sm last:border-0"
            key={month.month}
          >
            <div className="font-bold">{month.month}</div>
            <div className="text-right">{month.tips}</div>
            <div className="text-right">{month.wins}</div>
            <div
              className={`text-right font-bold ${month.profit >= 0 ? "text-emerald-300" : "text-rose-300"}`}
            >
              {month.profit > 0 ? "+" : ""}
              {month.profit}u
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
